import cx from "classnames";
import React from "react";
import { useTranslation } from "react-i18next";

let timeout = null;

function Toast({ open = false, type = "success", message }) {
  const { t } = useTranslation("common");
  const toastInput = React.useRef(null);

  if (process.browser) {
    if (open) closeLater(toastInput, type === "error" ? 10000 : 5000);
    else closeNow(toastInput);
  }
  return (
    <label className={cx("toast", type)} style={{ opacity: message ? 1 : 0 }}>
      <input
        type="checkbox"
        ref={toastInput}
        checked={open}
        onChange={() => {}}
      />
      <div className="toast-content">
        <div className={`toast-icon-wrapper ${type}`}>
          <img
            className={`toast-icon ${type}`}
            src={`/img/svg/toast-${type}.svg`}
            alt={`toast-${type}-icon`}
          />
        </div>
        <div className="toast-description">
          <span className={`toast-type-label ${type}`}>
            {t(`toast.type_${type}`)}{" "}
          </span>
          <span className="toast-message-label">
            {message?.replace(/\\n/g, "\n")}
          </span>
        </div>
        <button
          onClick={() => closeNow(toastInput)}
          className="cross-icon-wrapper"
          type="button"
        >
          <div className="cross-icon"></div>
        </button>
      </div>
    </label>
  );
}

function closeNow(toastInput) {
  if (toastInput.current) toastInput.current.checked = false;
}

function closeLater(toastInput, ms) {
  clearTimeout(timeout);
  timeout = setTimeout(() => {
    closeNow(toastInput);
  }, ms);
}

export default Toast;
